<div>
  <div class="row margin-top-8">
    <div class="col-md-3 label">
      {{ "bikeshop.modal.update_job_card.job_card.select_a_shop" | translate }}:
    </div>
    <div class="col-md-9 value">
      <p-dropdown [options]="shopList" [(ngModel)]="NewPartnerID" (onChange)="shopSelected()"></p-dropdown>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-3 label">
      {{ "bikeshop.modal.update_job_card.job_card.select_a_technician" | translate }}:
    </div>
    <div class="col-md-9 value">
      <p-dropdown [options]="technicianList" [(ngModel)]="NewTechnicianID" [disabled]="technicianList && technicianList.length===0"></p-dropdown>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-3 label">
      {{ "bikeshop.modal.update_job_card.job_card.select_serviceTypes" | translate }}:
    </div>
    <div class="col-md-9 value">
      <p-multiSelect [options]="serviceTypes" [(ngModel)]="selectedServiceTypes"
                     [optionLabel]="'label'"
                     [optionValue]="'value'"
                     [filter]="true" [showHeader]="true"
      [showToggleAll]="false" [disabled]="serviceTypes.length===0"></p-multiSelect>
    </div>
  </div>

  <div class="row margin-top-16">
    <div class="col-md-4">
      <button pButton type="button" [disabled]="movingJobcard" class="accent p-button-raised full-width" label="{{
          'general.cancel' | translate
        }}" (click)="cancel()"></button>
    </div>
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <button pButton type="button" [disabled]="!validateForm() || movingJobcard" class="p-button-raised full-width" label="{{
          'bikeshop.modal.update_job_card.job_card.move_jobcard' | translate
        }}" (click)="moveJobCard()"></button>
    </div>
</div>
